// FAQ.js

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function FAQ() {
  const { t } = useTranslation();
  const faqs = t('faq', { returnObjects: true });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white p-6 sm:p-12 pt-32">
      <h1 className="text-5xl font-extrabold text-center text-gray-700 mb-10 sm:mt-10 md:mt-20">{t('faqTitle')}</h1>
      <div className="max-w-4xl mx-auto space-y-6">
        {faqs.map((faq, index) => (
          <details key={index} className="group border-b-2 border-gray-300 pb-4">
            <summary className="cursor-pointer text-xl font-semibold text-gray-800 group-hover:text-gray-600 transition duration-300">
              {faq.question}
            </summary>
            <p className="mt-3 text-gray-600 leading-relaxed pl-4 border-l-4 border-gray-400">
              {faq.answer}
            </p>
          </details>
        ))}
      </div>
    </div>
  );
}